const Header = ({title}: IRoleHeaderProps) => {
  return <p className=" font-extrabold">{title}</p>;
};

export default Header;
